import { LabProof } from "@/components/LabProof";

/** Localised view of a ledger entry: French fields when present, English otherwise. */
export const localBatch = (b, lang) => (lang === "fr" && b?.fr ? { ...b, ...b.fr } : b);

export const BatchResult = ({ result, t, lang }) => {
  const b = localBatch(result, lang);
  const notes = Array.isArray(b?.notes) ? b.notes : [];
  return (
    <div data-testid="ledger-result" className="font-ledger">
      <div className="flex flex-wrap items-baseline justify-between gap-3 border-b border-[#B5A642]/40 pb-3">
        <h3 className="font-display text-3xl text-[#E8DDC7] font-light" data-testid="ledger-result-title">{b.title}</h3>
        <span className="text-[12px] text-[#B5A642]">{b.batch_no}</span>
      </div>
      {[[t("SEASON", "SAISON"), b.season], [t("REGION", "RÉGION"), b.region], [t("CONTENTS", "CONTENU"), b.mushrooms]].map(([k, v]) => (
        <div key={k} className="grid grid-cols-[96px_1fr] sm:grid-cols-[110px_1fr] gap-4 py-3 border-b border-[#303B2D]/60 text-[13px]">
          <span className="text-[#D3CEC4]/55">{k}</span>
          <span className="text-[#D3CEC4]/85">{v}</span>
        </div>
      ))}
      <div className="pt-4 space-y-2.5">
        {notes.map((n, i) => (
          <p key={i} className="text-[13px] leading-relaxed text-[#D3CEC4]/70 flex gap-3">
            <span className="text-[#B5A642]/60 shrink-0">{String(i + 1).padStart(2, "0")}</span>
            {n}
          </p>
        ))}
      </div>
      {b.lab && <LabProof batchNo={b.batch_no} lab={b.lab} sample={!!b.sample} t={t} />}
    </div>
  );
};
